import React from 'react';
import ReportIssueModal from './ReportIssueModal';
import { FiAlertTriangle } from 'react-icons/fi';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, showReportModal: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleOpenReport = () => {
    this.setState({ showReportModal: true });
  };

  handleCloseReport = () => {
    this.setState({ showReportModal: false });
  };

  render() {
    if (this.state.hasError) {
      const errorDescription = this.state.error
        ? `[Auto-captured error]\n${this.state.error.toString()}`
        : '';

      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="max-w-md w-full text-center">
            <FiAlertTriangle className="mx-auto h-12 w-12 text-amber-500 mb-4" />
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Something went wrong</h1>
            <p className="text-sm text-gray-600 mb-6">
              An unexpected error occurred. You can report this issue or reload the page.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={this.handleOpenReport}
                className="px-4 py-2 text-sm font-medium text-white bg-[#4f7a64] hover:bg-[#3d6350] rounded-lg transition-colors"
              >
                Report an Issue
              </button>
              <button
                onClick={this.handleReload}
                className="px-4 py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors"
              >
                Reload Page
              </button>
            </div>
          </div>

          {this.state.showReportModal && (
            <ReportIssueModal
              onClose={this.handleCloseReport}
              prefillDescription={errorDescription}
            />
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
